// 현재 위치(브라우저가 감지한) 타임존이 저장된 유저 타임존과 달라 "바꾸시겠어요?"
// 넛지 토스트를 띄워야 하는지 판단하는 순수 함수. 실제 감지(Intl)·토스트·localStorage
// 저장·mutate 는 클라이언트 훅(apps/app/src/hooks/UseTimezoneNudge.ts)이 맡고, 여기서는
// "띄울지 말지"의 결정 규칙만 값으로 못박는다(서버 import 가능한 매크로-free 모듈).

export interface TimezoneNudgeInput {
  /** 로그인(세션 확립) 이후인지. 로그인 전에는 넛지하지 않는다. */
  active: boolean;
  /** 저장된 유저 타임존. 아직 세션 미로드거나 설정 전이면 null/undefined. */
  userTimezone: string | null | undefined;
  /** 브라우저가 감지한 현재 위치의 IANA 타임존(detectTimezone()). */
  detectedTimezone: string;
  /** 유저가 바꾸지 않고 무시한 적 있는 감지 타임존(localStorage 기억값). 없으면 null. */
  dismissedTimezone: string | null;
}

/**
 * 넛지를 띄워야 하면 true. 모든 조건을 통과할 때만 참이다:
 *  - 로그인 이후(active)
 *  - 저장된 유저 타임존이 있음(비교 대상 존재)
 *  - 감지 타임존이 저장값과 다름(=바꿀 이유가 있음)
 *  - 이 감지 타임존을 아직 무시(거절)한 적 없음(같은 위치 재노출 억제)
 *
 * 수렴 성질: 유저가 "바꾸기"를 눌러 저장값이 감지값과 같아지면 다음 판단은 false 가 되어
 * 재노출되지 않는다(같은 감지 타임존을 무시해 둔 경우에도 동일).
 */
export function shouldShowTimezoneNudge({
  active,
  userTimezone,
  detectedTimezone,
  dismissedTimezone,
}: TimezoneNudgeInput): boolean {
  if (!active) return false;
  if (!userTimezone) return false;
  if (detectedTimezone === userTimezone) return false;
  if (dismissedTimezone === detectedTimezone) return false;
  return true;
}
